import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import styled from "@emotion/styled"
import { darken, readableColor } from "polished"

import { rhythm } from "@utils/typography"

const Collapse = styled(Accordion)`
  border: 1px solid rgba(0, 0, 0, 0.1);
`

const CollapseItem = styled(AccordionItem)``

const CollapseHeading = styled(AccordionItemHeading)``

const CollapseButton = styled(AccordionItemButton)`
  background-color: ${props => props.background || props.theme.color};
  border: none;
  color: ${props => readableColor(props.background || props.theme.color)};
  cursor: pointer;
  padding: ${rhythm(1 / 2)};
  text-align: left;
  width: 100%;
  &:hover,
  &:focus {
    background-color: ${props =>
      darken(0.1, props.background || props.theme.color)};
  }

  &:before {
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    content: "";
    display: inline-block;
    height: 10px;
    margin-right: ${rhythm(1 / 4)};
    transform: rotate(-45deg);
    width: 10px;
  }

  &[aria-expanded="true"]:before {
    transform: rotate(45deg);
  }
`

const CollapsePanel = styled(AccordionItemPanel)`
  padding: ${props => props.nopad ? false : rhythm(3 / 4)};
  padding-bottom: 0;
`

export {
  Collapse,
  CollapseItem,
  CollapseHeading,
  CollapseButton,
  CollapsePanel,
}
